import {useEffect} from 'react';
import moment from 'moment';

type UseEndTimeCalculateProps = {
    startTime: string | undefined;
    endTime: string | undefined;
    setValue: (name: string, value: any, options?: any) => void;
};

export const useEndTimeCalculate = ({startTime, endTime, setValue}: UseEndTimeCalculateProps) => {
    useEffect(() => {
        if (!startTime || !endTime) return;

        const start = moment(startTime);
        const end = moment(endTime);

        if (end.isBefore(start) || end.isSameOrBefore(start, 'minute')) {
            const correctedEnd = end.add(1, 'day');
            setValue('endTime', correctedEnd.format(), {shouldDirty: true});
        }
    }, [startTime, endTime, setValue]);
};
